<template>
  <CCol sm="6" md="4">
    <CCard :border-color="this.isActive ? 'success' : ''">
      <CCardHeader>
        <b>{{ group_name }}</b>:
        {{ release_date_hms }}
        <div class="card-header-actions">
          <CIcon name="cil-history" v-if="reviewed"/>
          <CBadge v-if="isActive" color="success">Рейтинг</CBadge>
          <CLink :href="yandex_link" class="card-header-action">
            <CIcon name="cil-music-note"/>
          </CLink>
          <small class="text-muted">{{ tracks_count }}</small>

        </div>
      </CCardHeader>
      <CCardBody>
        <div>
          <CButton
              color="outline-info"
              v-for="(value, key) in ['LP', 'EP', 'Single', 'Audiobook']"
              :key="key"
              class="mx-0"
              :pressed="value.toLowerCase() === albumType.toLowerCase() ? true : false"
              @click="albumType = value"
              :disabled="inProgress"
          >
            {{value}}
          </CButton>
        </div>
        <CImg :src="cover" align="center"></CImg>
        <CCardTitle>
          <h3 v-html="full_name"></h3>
        </CCardTitle>
<!--        <CCardFooter v-if="tracks_data">
          <ol>
            <li v-for="track in tracks_data" v-bind:key="track.id">{{ track.full_title }}</li>
          </ol>
        </CCardFooter>-->
        <CCardFooter v-if="tracks">
          <CListGroup>
            <CListGroupItem
                class="d-flex justify-content-between align-items-center"
                href="#"
                v-for="track in tracks"
                v-bind:key="track.id"
                @click="inRatingUpdateTrack(track)"
                :color="(track.in_rating) ? 'success' : (isTrackDuplicate(track)) ? 'danger' : ((track.is_suggested) ? 'warning' : '')"
            >
              <div>
                <CIcon v-if="track.is_suggested" name="cil-flag-alt"/>
                <CIcon v-if="track.best" name="cil-bolt"/>
                <CIcon v-if="isTrackDuplicate(track)" name="cil-chevron-double-left" v-c-tooltip="{content: format_date(track.first_release_date) }"/>
                {{ track.full_title }}
                <CIcon v-if="track.in_rating" name="cil-check"/>
              </div>
              <CBadge color="light">{{ duration_hms(track.duration) }}</CBadge>
            </CListGroupItem>
          </CListGroup>
        </CCardFooter>

      </CCardBody>
      <CCardFooter>
        <CButton block variant="outline" color="success" :disabled="inProgress" size="lg" :pressed="isActive"
                 @click="inRatingUpdate">
          {{ isActive ? 'В Рейтинге' : 'Отметить' }}
        </CButton>
      </CCardFooter>
    </CCard>
  </CCol>
</template>

<script>
export default {
  name: 'AlbumCard',
  props: [
    'id',
    'ya_id',
    'full_name',
    'description',
    'in_rating',
    'reviewed',
    'group_name',
    'tracks_count',
    'tracks_data',
    'tracks',
    'release_date',
    'type',
    'ya_genres',
    'ya_important',
    'cover',
    'url',
  ],
  mounted () {

  },
  data () {
    return {
      isActive: (this.in_rating == true),
      inProgress: false,
      isCollapsed: true,
    };
  },
  computed: {
    release_date_hms: function () {
      var date = new Date(this.release_date);
      return this.$moment(date).format('DD.MM.YYYY');
    },
    yandex_link: function () {
      if (this.url) {
        return this.url
      }
      return 'https://music.yandex.ru/album/' + this.ya_id;
    },
    albumType: {
      get(){
        return this.type
      },
      set(val){
        this.typeUpdate(val)
        return val
      }
    }
  },
  methods: {
    inRatingUpdate () {
      this.inProgress = true;
      this.$http.post('/api/album/' + this.id,
          {
            in_rating: !this.isActive,
          },
      ).then(response => {
        this.inProgress = false;
        this.isActive = response.data.data.in_rating;
        this.tracks = response.data.data.tracks;
      });
    },
    typeUpdate (val) {
      this.inProgress = true;
      this.$http.post('/api/album/' + this.id,
          {
            type: val,
          },
      ).then(response => {
        this.inProgress = false;
        this.type = response.data.data.type;
      });
    },
    inRatingUpdateTrack (track) {
      this.inProgress = true;
      this.$http.post('/api/track/' + track.id,
          {
            in_rating: !track.in_rating,
          },
      ).then(response => {
        this.inProgress = false;
        track.in_rating = response.data.data.in_rating;
      });
    },
    duration_hms: function (duration) {
      if (duration == null) {
        return '-';
      }
      var date = new Date(2020, 1, 1, 0, 0, 0);
      date.setSeconds(duration);
      var hasHours = (date.getHours() > 0);
      return hasHours ? this.$moment(date).format('HH:mm:ss') : this.$moment(date).format('mm:ss');
    },
    isTrackDuplicate: function(track) {
      return track.release_date !== track.first_release_date
    },
    format_date: function(date) {
      let dateObj = new Date(date);
      return this.$moment(dateObj).format('DD.MM.YYYY');
    }
  },
  watch: {
    /*isActive: function (val) {

    },*/
  },
};
</script>

<style scoped>

</style>